<template>
  <footer id="footer" class="ct-footer" data-id="type-1" itemscope="" itemtype="https://schema.org/WPFooter">
    <div data-row="middle">
      <div class="ct-container">
        <div data-column="widget-area-1">
          <div class="ct-widget widget_block widget_media_image" id="block-10">
            <figure class="wp-block-image size-full is-resized">
              <img loading="lazy" decoding="async" width="1024" height="1024"
                src="/wp-content/uploads/2024/02/image_2024-02-06_221432513.png" alt="" class="wp-image-815"
                style="width:126px;height:auto"
                srcset="/wp-content/uploads/2024/02/image_2024-02-06_221432513.png 1024w, /wp-content/uploads/2024/02/image_2024-02-06_221432513-300x300.png 300w, /wp-content/uploads/2024/02/image_2024-02-06_221432513-150x150.png 150w, /wp-content/uploads/2024/02/image_2024-02-06_221432513-768x768.png 768w"
                sizes="(max-width: 1024px) 100vw, 1024px" />
            </figure>
          </div>

          <div class="ct-widget widget_block widget_text" id="block-65">
            <p><strong>High Risk Investment Disclaimer:</strong> Trading foreign exchange and stock markets carries
              a high level of risk, as well high level of returns. Level of leverage may not be suitable for all
              investors. Before deciding to trade foreign exchange, you should carefully consider your investment
              objectives, level of experience and risk appetite. As a result of various financial fluctuations, you
              may not only significantly increase your capital, but also lose it completely. Therefore our clients
              have to assure Socrates Legacy LTD, that they understand all the possible consequences of such risks,
              they know all the specifics rules and regulations, governing the use of investment products, including
              corporate events, resulting in the exchange of underlying assets. Client understands that there are
              special risks and features that affect prices, exchange rates and investment products.</p>
          </div>

          <div class="ct-widget widget_block widget_text" id="block-66">
            <p>Socrates Legacy LTD, as a financial service provider, restricts its services to residents of certain
              countries due to differing local laws and regulations. These are Mauritius, Japan, Canada, Haiti,
              Iran, Suriname, the Democratic Republic of Korea, Puerto Rico, the Occupied Area of Cyprus, Russia,
              Ukraine, Quebec, Iraq, Syria, Cuba, Belarus, Myanmar, United Kingdom, United States of America
              (including its territories).</p>
          </div>

          <div class="ct-widget widget_block widget_text" id="block-71">
            <p>By entering any page on our website, you are consenting to adhere to the terms and conditions
              provided herein. socrateslegacy.com retains the authority to alter or update these terms at its
              discretion without prior notice. It is your obligation to periodically review the terms to ensure that
              your utilization of the website and its services consistently aligns with the terms and conditions. We
              urge you to carefully read and understand the terms of use.</p>
          </div>

          <div class="ct-widget widget_block widget_text" id="block-72">
            <p>Additionally, the information on the company's website is not targeted towards residents of U.S.,
              Israel, New Zealand, Iran, and North Korea, officially known as the Democratic People's Republic of
              Korea, or use by any person in any country where it would be illegal.</p>
          </div>
        </div>

        <div data-column="widget-area-4">
          <div class="ct-widget widget_block" id="block-8">
            <div class="ct-block-wrapper">
              <h3 class="wp-block-heading widget-title">
                <span style="text-decoration: underline;">Official Info</span>:
              </h3>

              <p>Registered Office Address in Union of Comoros.</p>

              <div class="ct-contact-info-block"
                style="--theme-icon-size:20px;--items-direction:column;--background-color:rgba(218, 222, 228, 0.5);--background-hover-color:rgba(218, 222, 228, 0.7);">
                <ul data-icons-type="rounded:outline">
                  <li>
                    <span class="ct-icon-container">
                      <svg width="18" height="18" viewBox="0 0 384 512" fill="currentColor" aria-hidden="true">
                        <path
                          d="M168.3 499.2C116.1 435 0 279.4 0 192C0 85.96 85.96 0 192 0C298 0 384 85.96 384 192C384 279.4 267.9 435 215.7 499.2C203.4 514.5 180.6 514.5 168.3 499.2H168.3zM192 256C227.3 256 256 227.3 256 192C256 156.7 227.3 128 192 128C156.7 128 128 156.7 128 192C128 227.3 156.7 256 192 256z" />
                      </svg>
                    </span>
                    <div class="contact-info">
                      <span class="contact-title">Address: </span>
                      <span class="contact-text">
                        Hamchaku, Mustsamuda, Atonomes Island of Anjouan Union of Comoros.
                      </span>
                    </div>
                  </li>
                  <li>
                    <span class="ct-icon-container">
                      <svg width="18" height="18" viewBox="0 0 512 512" fill="currentColor" aria-hidden="true">
                        <path
                          d="M164.9 24.6c-7.7-18.6-28-28.5-47.4-23.2l-88 24C12.1 30.2 0 46 0 64C0 311.4 200.6 512 448 512c18 0 33.8-12.1 38.6-29.5l24-88c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6L304.7 368C234.3 334.7 177.3 277.7 144 207.3l49.4-40.4c13.7-11.1 18.4-30 11.6-46.3l-40-96z" />
                      </svg>
                    </span>
                    <div class="contact-info">
                      <span class="contact-title">Phone: </span>
                      <span class="contact-text">
                        <a href="tel:578-393-4937">(+1) 3153090077</a>
                      </span>
                    </div>
                  </li>
                  <li>
                    <span class="ct-icon-container">
                      <svg width="18" height="18" viewBox="0 0 512 512" fill="currentColor" aria-hidden="true">
                        <path
                          d="M48 64C21.5 64 0 85.5 0 112c0 15.1 7.1 29.3 19.2 38.4L236.8 313.6c11.4 8.5 27 8.5 38.4 0L492.8 150.4c12.1-9.1 19.2-23.3 19.2-38.4C512 85.5 490.5 64 464 64H48zM0 176V384c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V176L294.4 339.2c-22.8 17.1-54 17.1-76.8 0L0 176z" />
                      </svg>
                    </span>
                    <div class="contact-info">
                      <span class="contact-title">Email: </span>
                      <span class="contact-text">
                        <a href="mailto:cs@socrateslegacy.com">cs@socrateslegacy.com</a>
                      </span>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div data-column="widget-area-3">
          <div class="ct-widget widget_block" id="block-42">
            <h3 class="wp-block-heading widget-title">
              <span style="text-decoration: underline;">Regulations:</span>
            </h3>
          </div>

          <div class="ct-widget widget_block widget_text" id="block-35">
            <p>Socrates Legacy is operated by Socrates Legacy LTD and has registered by <strong>Comoros
                Union</strong> with <strong>International Brokerage and Clearing Houses license</strong>.</p>
          </div>

          <div class="ct-widget widget_block widget_text" id="block-36">
            <p>License Number : <strong>L 34695 /SL</strong> </p>
          </div>

          <div class="ct-widget widget_block" id="block-39">
            <div class="wp-block-buttons is-layout-flex wp-block-buttons-is-layout-flex">
              <div class="wp-block-button">
                <router-link class="wp-block-button__link wp-element-button" to="/about?tab=regulation">See
                  More</router-link>
              </div>
            </div>
          </div>

          <div class="ct-widget widget_block" id="block-44">
            <h3 class="wp-block-heading widget-title">
              <span style="text-decoration: underline;">Socials:</span>
            </h3>
          </div>

          <div class="ct-widget widget_block" id="block-45">
            <div class="ct-block-wrapper">
              <div class="ct-socials-block">
                <div class="ct-social-box" data-color="default" data-icons-type="simple">
                  <a href="#" data-network="facebook" aria-label="Facebook" rel="noopener">
                    <span class="ct-icon-container">
                      <svg width="20px" height="20px" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                        <path
                          d="M20,10.1c0-5.5-4.5-10-10-10S0,4.5,0,10.1c0,5,3.7,9.1,8.4,9.9v-7H5.9v-2.9h2.5V7.9C8.4,5.4,9.9,4,12.2,4c1.1,0,2.2,0.2,2.2,0.2v2.5h-1.3c-1.2,0-1.6,0.8-1.6,1.6v1.9h2.8L13.9,13h-2.3v7C16.3,19.2,20,15.1,20,10.1z" />
                      </svg>
                    </span>
                  </a>
                  <a href="#" data-network="twitter" aria-label="X (Twitter)" rel="noopener">
                    <span class="ct-icon-container">
                      <svg width="20px" height="20px" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                        <path
                          d="M2.9 0C1.3 0 0 1.3 0 2.9v14.3C0 18.7 1.3 20 2.9 20h14.3c1.6 0 2.9-1.3 2.9-2.9V2.9C20 1.3 18.7 0 17.1 0H2.9zm13.2 3.8L11.5 9l5.5 7.2h-4.3l-3.3-4.4-3.8 4.4H3.4l5-5.7-5.3-6.7h4.4l3 4 3.5-4h2.1zM14.4 15 6.8 5H5.6l7.7 10h1.1z" />
                      </svg>
                    </span>
                  </a>
                  <a href="#" data-network="instagram" aria-label="Instagram" rel="noopener">
                    <span class="ct-icon-container">
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                        <circle cx="10" cy="10" r="3.3" />
                        <path
                          d="M14.2,0H5.8C2.6,0,0,2.6,0,5.8v8.3C0,17.4,2.6,20,5.8,20h8.3c3.2,0,5.8-2.6,5.8-5.8V5.8C20,2.6,17.4,0,14.2,0zM10,15c-2.8,0-5-2.2-5-5s2.2-5,5-5s5,2.2,5,5S12.8,15,10,15z M15.8,5C15.4,5,15,4.6,15,4.2s0.4-0.8,0.8-0.8s0.8,0.4,0.8,0.8S16.3,5,15.8,5z" />
                      </svg>
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div class="ct-widget widget_block" id="block-47">
            <h3 class="wp-block-heading widget-title">
              <span style="text-decoration: underline;">Platform:</span>
            </h3>
          </div>

          <div class="ct-widget widget_block widget_media_image" id="block-48">
            <figure class="wp-block-image size-full is-resized">
              <img loading="lazy" decoding="async" width="981" height="250"
                src="/wp-content/uploads/2024/02/image_2024-02-06_223940507.png" alt="" class="wp-image-818"
                style="width:177px;height:auto"
                srcset="/wp-content/uploads/2024/02/image_2024-02-06_223940507.png 981w, /wp-content/uploads/2024/02/image_2024-02-06_223940507-300x76.png 300w, /wp-content/uploads/2024/02/image_2024-02-06_223940507-768x196.png 768w"
                sizes="(max-width: 981px) 100vw, 981px" />
            </figure>
          </div>
        </div>
      </div>
    </div>

    <div data-row="bottom">
      <div class="ct-container">
        <div data-column="copyright">
          <div class="ct-footer-copyright" data-id="copyright">
            <p>Copyright © Socrates Legacy Ltd. 2024 | <strong><a
                  href="/assets/legal/Socrates-Legal-Documents.pdf">Legal
                  Document</a></strong></p>
          </div>
        </div>
        <div data-column="ghost"></div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'LandingFooter'
}
</script>